import * as actionTypes from '../actions/actionTypes'
const initState = {
    response: [],
    type: '',
    message: '',
}

export default (state = initState, action = {}) => {
    switch (action.type) {
        case actionTypes.ADD_SUBUSER_REQUEST:
            return {
                ...state,
                type:"",
                response: [],
                message: '',
            }
        case actionTypes.ADD_SUBUSER_SUCCESS:

            return {
                ...state,
                type:"add",
                response: action.payload.data,
                message: 'Success Data',
            }
        case actionTypes.ADD_SUBUSER_ERROR:
        
            return {
                ...state,
                type:"error",
                responseErr: action.payload.response.data,
                message: 'Error',
            }

        case actionTypes.SUBUSER_LIST_REQUEST:
            return {
                ...state,
                type:"",
                response: [],
                message: '',
            }
        case actionTypes.SUBUSER_LIST_SUCCESS:
            return {
                ...state,
                type:"List",
                response: action.payload.data,
                message: 'Success Data',
            }
        case actionTypes.SUBUSER_LIST_ERROR:
            return {
                ...state,
                type:"",
                response: [],
                message: 'Error',
            }


        case actionTypes.SUBUSER_STATUS_REQUEST:
            return {
                ...state,
                type:"",
                response: [],
                message: '',
            }

        case actionTypes.SUBUSER_STATUS_SUCCESS:
            return {
                ...state,
                type:"update",
                response: action.payload.data,
                message: 'Success Data',
            }
        case actionTypes.SUBUSER_STATUS_ERROR:
            return {
                ...state,
                type:"error",
                response: [],
                message: 'Error',
            }
            
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/Subuser.js